/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetRegisteredUsersReportAggregateByDayOptions, GetRegisteredUsersReportAggregateByDayResponses } from '../../models/GetRegisteredUsersReportAggregateByDay'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Registered Users Aggregate By Day
 * {@link /reports/registered_users/aggregate-by-day}
 */
export function getRegisteredUsersReportAggregateByDay<ThrowOnError extends boolean = true>(options: Options<GetRegisteredUsersReportAggregateByDayOptions, ThrowOnError>): Promise<UnwrappedResult<GetRegisteredUsersReportAggregateByDayResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/reports/registered_users/aggregate-by-day', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetRegisteredUsersReportAggregateByDayResponses, ThrowOnError>>
}
